module.exports = __webpack_public_path__ + "img/icon_stop.43c85533.svg";